var _ = require("underscore");
var dictionary = require("../../../dictionary/texts.json")
var greek = dictionary["el"];
var english = dictionary["en"];

var i18n = require("i18next");

i18n.init({
    fallbackLng: "el",
    resStore: dictionary,
    lngWhitelist: ["el", "en"],
    defaultLng: "el"
    //cookieDomain: "q-edis.com"
});

var translations = {
    "el": greek,
    "en": english
};

i18n.truncLang = function () {
    var i = i18n.options.lng.indexOf("-");
    if (i === -1) {
        return i18n.options.lng;
    }
    else {
        return i18n.options.lng.substring(0, i);
    }
};


i18n.findCountryFromCode = function (code) {
    var array = translations[i18n.options.lng];
    return array[code];
};

i18n.getCountries = function () {
    return translations[i18n.options.lng];
};

console.log("Loaded dictionary. Translation of Name: " + i18n.t("queue.name"));

module.exports = i18n;
